import { useSelector } from "react-redux";

const PageInfoBar = ({ currentNo, totalNo }) => {
  const { mode } = useSelector((state) => state.ui);
  const isMobile = mode === "mobile";

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        height: isMobile ? "40px" : "70px",
        fontSize: isMobile ? "12px" : "16px",
        width: "100vw",
        backgroundColor: "#F6F8FA", // 바 색상
        color: "#737373",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {currentNo} / {totalNo}
    </div>
  );
};

export default PageInfoBar;
